(function () {
  function initCsPdpTestimonials(container) {
    const slider = container.querySelector('[data-cs-pdp-testimonials-slider]')
    if (!slider || typeof Swiper === 'undefined') return null

    const scrollbar = container.querySelector('[data-cs-pdp-testimonials-scrollbar]')

    return new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      watchOverflow: true,
      centerInsufficientSlides: true,
      scrollbar: scrollbar ? { el: scrollbar, draggable: true } : false,
      a11y: {
        enabled: true
      }
    })
  }

  function setupCsPdpTestimonials(root) {
    const containers = root.querySelectorAll('[data-cs-pdp-testimonials]')
    containers.forEach((container) => {
      if (container.csPdpTestimonialsSwiper) return
      container.csPdpTestimonialsSwiper = initCsPdpTestimonials(container)
    })
  }

  function destroyCsPdpTestimonials(root) {
    const containers = root.querySelectorAll('[data-cs-pdp-testimonials]')
    containers.forEach((container) => {
      if (!container.csPdpTestimonialsSwiper) return
      container.csPdpTestimonialsSwiper.destroy(true, true)
      container.csPdpTestimonialsSwiper = null
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupCsPdpTestimonials(document))
  } else {
    setupCsPdpTestimonials(document)
  }

  document.addEventListener('shopify:section:load', (event) => {
    setupCsPdpTestimonials(event.target)
  })

  document.addEventListener('shopify:section:unload', (event) => {
    destroyCsPdpTestimonials(event.target)
  })
})()
